import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import QtyControl from './QtyControl';
import type { CartItemRowProps } from '../types';

const CartItemRow: React.FC<CartItemRowProps> = ({
    itemKey: _itemKey,
    item,
    onIncrement,
    onDecrement,
    onRemove,
    canShowKOTDescription,
    onDescriptionChange,
}) => {
    const [showDescription, setShowDescription] = useState(false);
    const lineTotal = (item.selectedVariants?.value || 0) * (item.selected || 0);
    const hasDescription = !!(item.itemDescription && item.itemDescription.trim());

    return (
        <div className="posv2-cart-item">
            <div className="posv2-cart-item__main">
                <div className="posv2-cart-item__info">
                    <p className="posv2-cart-item__name">
                        {(item.name || '').replaceAll('-', ' ')}
                    </p>
                    <span className="posv2-cart-item__variant">
                        {item.selectedVariants?.label}
                    </span>
                </div>

                <div className="posv2-cart-item__controls">
                    <QtyControl
                        quantity={item.selected || 0}
                        onIncrement={onIncrement}
                        onDecrement={onDecrement}
                        size="sm"
                    />
                </div>

                <div className="posv2-cart-item__price">₹{lineTotal}</div>

                <IconButton
                    size="small"
                    className="posv2-cart-item__delete"
                    onClick={onRemove}
                    aria-label={`Remove ${item.name}`}
                >
                    <DeleteOutlineIcon sx={{ fontSize: 17 }} />
                </IconButton>
            </div>

            {canShowKOTDescription && onDescriptionChange && (
                <div className="posv2-cart-item__kot">
                    <button
                        type="button"
                        className="posv2-cart-item__kot-toggle"
                        onClick={() => setShowDescription((s) => !s)}
                    >
                        {showDescription ? <ExpandLessIcon sx={{ fontSize: 17 }} /> : <ExpandMoreIcon sx={{ fontSize: 17 }} />}
                        <span>KOT instructions {hasDescription && '(added)'}</span>
                    </button>
                    {showDescription && (
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Add instructions for kitchen..."
                            value={item.itemDescription || ''}
                            onChange={(e) => onDescriptionChange(e.target.value)}
                            multiline
                            maxRows={2}
                            variant="outlined"
                            className="posv2-cart-item__kot-input"
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default React.memo(CartItemRow);
